module.exports = __webpack_public_path__ + "static/media/right 1.226117e1.svg";